/**
 * Created by Carsten Bühler
 * User: CBuehler on 25.09.2015
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import * as DateFormat from '../utils/date-format.js';
import { Col, Row } from 'external/react-bootstrap';
import DateTimeDisplay from './DateTimeDisplay';

const ObjectDates = ({ dataItem },) => {
    const item = dataItem;
    return (
        <div className="padding-box-v">
            <h4>Daten</h4>
            {item &&
            <React.Fragment>
                <Row>
                    <Col lg={4} md={4} sm={4} xs={4}>Erstellt:</Col>
                    <Col lg={8} md={8} sm={8} xs={8}>
                        <DateTimeDisplay timestamp={item.createDate} dateFormat={DateFormat.formatDateTimeNoSeconds}/>
                    </Col>
                </Row>
                <Row>
                    <Col lg={4} md={4} sm={4} xs={4}>Geändert:</Col>
                    <Col lg={8} md={8} sm={8} xs={8}>
                        <DateTimeDisplay timestamp={item.modifiedDate} dateFormat={DateFormat.formatDateTimeNoSeconds}/>
                    </Col>
                </Row>
            </React.Fragment>
            }
        </div>
    );
};

ObjectDates.propTypes = {
    dataItem: PropTypes.object
};

export default ObjectDates;



// WEBPACK FOOTER //
// ./js/components/ObjectDates.jsx